<template>
  <v-alert
    elevation="3"
    :dismissible="true"
    class="alert"
    :type="value.type"
    v-model="value.active"
  >
    {{ value.message }}
  </v-alert>
</template>
<script>
export default {
  props: {
    value: {
      type: Object
    }
  }
};
</script>
<style lang="sass">
.alert
  right: 1.5rem
  position: fixed !important
  z-index: 300
</style>
